import {
    Checkbox,
    TableCell,
    TableRow,
    IconButton,
    Tooltip
} from '@mui/material';
import { MoreVert as MoreVertIcon } from '@mui/icons-material';
import { ICliente } from '../../interface/ICliente';
import { useDataHora } from '../../../core/hooks/useDataHora';

interface ClienteTableRowProps {
    cliente: ICliente;
    selecionado: boolean;
    toggleSelecionado: (uuid: string) => void;
    onDetalhes: (cliente: ICliente) => void;
}

export const ClienteTableRow = ({ 
    cliente, 
    selecionado, 
    toggleSelecionado, 
    onDetalhes
}: ClienteTableRowProps) => {
    const { dataHoraBr } = useDataHora();
    
    return (
        <TableRow
            selected={selecionado}
            hover
            role="checkbox"
            aria-checked={selecionado}
        >
            <TableCell padding="checkbox">
                <Checkbox
                    checked={selecionado}
                    onChange={() => cliente.uuid && toggleSelecionado(cliente.uuid)}
                />
            </TableCell>
            <TableCell align="left" width="25%">{cliente.nome}</TableCell>
            <TableCell align="left" width="25%">{cliente.telefone?.length ? cliente.telefone : "-"}</TableCell>
            <TableCell align="left" width="25%">{cliente.observacao?.length ? cliente.observacao : "-"}</TableCell>
            <TableCell align="left" width="20%">{dataHoraBr(cliente.cadastradoAs)}</TableCell>
            <TableCell align="center" width="5%">
                <Tooltip title="Ver detalhes dos pedidos">
                    <IconButton 
                        onClick={() => onDetalhes(cliente)} 
                        aria-label="detalhes" 
                        size="small"
                    >
                        <MoreVertIcon fontSize="inherit" />
                    </IconButton>
                </Tooltip>
            </TableCell>
        </TableRow>
    );
};
